// Build-time feature flags.
//
// Values come from `VITE_FEATURE_*` env vars, inlined by Vite at build time
// (same mechanism as the Clerk/Sentry/PostHog keys). They are environment-
// dependent, NOT user-dependent. Default is OFF: a feature is hidden unless
// its var is explicitly set to "true". Flipping one on requires a rebuild.
const enabled = (value) => String(value).toLowerCase() === 'true';

// Launched features are ON by default; the env var flips to an explicit
// KILL SWITCH ("false" disables). Anything else — unset, "true", typos —
// leaves the feature on, so production can't accidentally dark-launch it.
const launchedUnlessDisabled = (value) => String(value).toLowerCase() !== 'false';

export const FEATURES = {
    // Launched 2026-07-17 (maintenance-finish PR sequence; user decision to
    // show the real page in production instead of the ComingSoon gate).
    maintenance: launchedUnlessDisabled(import.meta.env.VITE_FEATURE_MAINTENANCE),
    models3d: enabled(import.meta.env.VITE_FEATURE_MODELS_3D),
};
